export default __webpack_public_path__ + "static/with-phone-ed1f7177ecb4b7b08baab930a53fbbc5.webp";